import React from "react";
import  * as uuidv4 from "uuid/v4";
import { CONTENT_TYPE, RENDER_FORMAT, PIVOT_KEY, LOG_LEVEL } from './consts';

export const MessagesContext = React.createContext({
  messages: [
    //{ id: uuidv4(), text: "This is a sample item", selected: false }
  ],
  selectedItems: [],
  currentMessage: {},
  numberOfItemsInPage: 10,
  bodyContent : '',
  bodyContentType : CONTENT_TYPE.HTML,
  titleContent : 'Meeting Content',
  titleContentType : CONTENT_TYPE.TEXT,
  textBody : '',
  htmlBody : '',
  editorState : null,
  renderFormat : RENDER_FORMAT.RichTextHtml,
  loadSelectedItems : true,
  pivotKey: PIVOT_KEY.TEAMS,
  logLevel : LOG_LEVEL.SILENT,
  emailFrom : 'info@cohorts.app',
  emailTo : 'info@cohorts.app',
  emailSubject : 'Teams Meeting Summary',
  emailHeader : 
`<br/>Meeting date: <br/>
Teams Meeting Subject:<br/><br/>
Attendees:<br/><br/>`,
  emailFooter : 
`Date : <br/><br/>
Meeting summary notes written by:<br/>`
});

